import {Client, IMessage, StompConfig} from '@stomp/stompjs';
import {AuthenticationService} from '../../services/authentication.service';

export abstract class AbstractStompService {

    public readonly stompClient: Client;

    private config: StompConfig;

    protected constructor(
        protected authenticationService: AuthenticationService
    ) {
        this.config = this.defaultConfig();
        this.stompClient = new Client(this.config);
    }

    public abstract servicePath(): string;

    public abstract receivingPrefix(): string;

    public configure(name: string, value: any) {
        this.config[name] = value;
        this.stompClient.configure(this.config);
    }

    protected defaultConfig(): StompConfig {
        const token = this.authenticationService.getTokenInfo().accessToken;
        const cleanPath = this.servicePath().startsWith('/') ? this.servicePath().substr(1) : this.servicePath();
        const protocol = location.protocol.includes('https') ? 'wss' : 'ws';
        const host = `${protocol}://${window.location.host}/ws/${cleanPath}/websocket/stomp`;

        return {
            brokerURL: host,
            connectHeaders: { Authorization: token },
            reconnectDelay: 0,
            debug: (evt) => console.log(evt)
        };
    }

    public subscribe(path: string, callback: (body: any) => any) {
        const cleanReceivingPrefix = this.receivingPrefix().startsWith('/') ?
            this.receivingPrefix().substr(1) :
            this.receivingPrefix();
        const cleanPath = path.startsWith('/') ? path.substr(1) : path;
        this.stompClient.subscribe(`/user/${cleanReceivingPrefix}/${cleanPath}`, (msg: IMessage) => {
            return callback(JSON.parse(msg.body));
        });
    }

    public publish(path: string, body?: any) {
        if (this.stompClient.connected) {
            const token = this.authenticationService.getTokenInfo().accessToken;

            const cleanPath = path.startsWith('/') ? path.substr(1) : path;
            this.stompClient.publish({
                destination: `/app/${cleanPath}`,
                body: JSON.stringify(body || ''),
                headers: { Authorization: token }
            });
        }
    }

    public disconnect() {
        if (this.stompClient.connected) {
            this.stompClient.deactivate();
        }
    }
}
